import { render, staticRenderFns } from "./UploadVideoBattle.vue?vue&type=template&id=44712ed4&scoped=true"
import script from "./UploadVideoBattle.vue?vue&type=script&lang=js"
export * from "./UploadVideoBattle.vue?vue&type=script&lang=js"
import style0 from "./UploadVideoBattle.vue?vue&type=style&index=0&id=44712ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44712ed4",
  null
  
)

export default component.exports